import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

/*
	The generic <T> looks useless here, but don't remove it.
	Sometimes our language types are `string` and sometimes they're `LanguagesAbbr` and sometimes `LanguagesAbbrV2`.
	This lets us specify which one we want when we use the hook.
*/
const useLanguageParams = <T = string>(): T | undefined => {
  const params = useParams();
  const language = params?.language;

  return useMemo(() => {
    return language as T;
  }, [language]);
};

export default useLanguageParams;
